import { useTranslation } from 'react-i18next';

const testimonials = [
  { nameKey: 'testimonials.user1_name', handleKey: 'testimonials.user1_handle', textKey: 'testimonials.user1_text' },
  { nameKey: 'testimonials.user2_name', handleKey: 'testimonials.user2_handle', textKey: 'testimonials.user2_text' },
  { nameKey: 'testimonials.user3_name', handleKey: 'testimonials.user3_handle', textKey: 'testimonials.user3_text' },
  { nameKey: 'testimonials.user4_name', handleKey: 'testimonials.user4_handle', textKey: 'testimonials.user4_text' },
  { nameKey: 'testimonials.user5_name', handleKey: 'testimonials.user5_handle', textKey: 'testimonials.user5_text' },
  { nameKey: 'testimonials.user6_name', handleKey: 'testimonials.user6_handle', textKey: 'testimonials.user6_text' },
];

export default function Testimonials() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-24 md:py-32 px-4 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium mb-8">
          {t('testimonials.label')}
        </span>

        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight mb-16">
          {t('testimonials.heading1')}
          <br />
          {t('testimonials.heading2')}
        </h2>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {testimonials.map((item, idx) => (
            <div
              key={idx}
              className="break-inside-avoid bg-background-50 rounded-2xl p-6 transition-all duration-300 hover:scale-[1.01]"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center flex-shrink-0">
                  <span className="text-secondary-700 text-sm font-bold">
                    {t(item.nameKey).charAt(0)}
                  </span>
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-semibold text-foreground-800">{t(item.nameKey)}</span>
                  <span className="text-xs text-foreground-500">{t(item.handleKey)}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                &ldquo;{t(item.textKey)}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}